import { render } from "./TravelPassStopsModal.vue?vue&type=template&id=2160c9f6&scoped=true&lang=pug"
import script from "./TravelPassStopsModal.vue?vue&type=script&lang=ts"
export * from "./TravelPassStopsModal.vue?vue&type=script&lang=ts"

import "./TravelPassStopsModal.vue?vue&type=style&index=0&id=2160c9f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2160c9f6"

export default script